import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatStepperModule} from '@angular/material/stepper';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { OdsV2Component } from './ods-v2.component';

const rutas: Routes = [
    {
        path     : 'profile-creator/company',
        component: OdsV2Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'companies/edit/:id',
        component: OdsV2Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    }
];

@NgModule({
  declarations: [
    OdsV2Component
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatProgressSpinnerModule
  ]
})
export class OdsV2Module { }
